import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { ROUTES, useNavigate } from 'libs/navigation';
import { ClientsOrLegalClientsView } from 'modules/client/common/views';

import {
  LegalClientsFilters,
  LegalClientsTable,
  LegalClientsTableProps,
} from '../components';
import { LegalClientsFilterTypes } from '../types';

export interface ClientsViewProps extends LegalClientsTableProps {
  filter: LegalClientsFilterTypes;
  setFilter: (filter?: LegalClientsFilterTypes | undefined) => void;
  registrationCountries?: CountryEntity[];
  locationCountries?: CountryEntity[];
}

export const LegalClientsView: FC<ClientsViewProps> = ({
  setFilter,
  filter,
  registrationCountries,
  locationCountries,
  ...tableProps
}) => {
  const { t } = useTranslation();
  const { navigate } = useNavigate();

  const { search } = filter;

  const countFilter =
    lodash.defaultTo([filter?.statuses?.length], 0) +
    lodash.defaultTo([filter?.riskLevels?.length], 0) +
    lodash.defaultTo([filter?.locationCountries?.length], 0) +
    lodash.defaultTo([filter?.registrationCountries?.length], 0);

  const noRowsLabel =
    (!!countFilter && t('components.table.filterEmptyData')) ||
    (!!search && t('components.table.searchEmptyData')) ||
    undefined;

  const handleAddClick = () => {
    navigate(ROUTES.clients.legalClients.createLegalClient.fullPath, {});
  };

  return (
    <ClientsOrLegalClientsView
      filter={filter}
      FilterComponent={LegalClientsFilters}
      locationCountries={locationCountries}
      registrationCountries={registrationCountries}
      setFilter={setFilter}
      toggleButtonValue="legal"
      onClickAdd={handleAddClick}
    >
      <LegalClientsTable {...tableProps} noRowsLabel={noRowsLabel} />
    </ClientsOrLegalClientsView>
  );
};
